import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, object, string } from "yup";

export type CurrentSolutionWrapperFormType = {
  readonly formType: string;
  readonly institution?: string;
};

export const getCurrentSolutionWrapperFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<CurrentSolutionWrapperFormType> = (t) => {
  return object({
    formType: string().required(t(Resources.Validation.Required)),
    institution: string().optional(),
  }).defined();
};
